import React from 'react';

type Props = {
    ataData: any;
};

type State = {
    checked: boolean;
};

const styles: Record<string, React.CSSProperties> = {
    page: {
        fontFamily: 'Arial, sans-serif',
        fontSize: '12px',
        padding: '20px 30px',
        color: '#000',
    },
    headerContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderBottom: '2px solid #000',
        paddingBottom: '10px',
        marginBottom: '15px',
    },
    logo: {
        width: '80px',
        height: 'auto',
        marginRight: '15px',
    },
    headerText: {
        flex: 1,
    },
    headerTitle: {
        fontSize: '16px',
        fontWeight: 'bold',
        margin: 0,
    },
    headerSubtitle: {
        fontSize: '13px',
        margin: '2px 0',
    },
    headerAta: {
        fontSize: '14px',
        fontWeight: 'bold',
        margin: '4px 0 0 0',
        textAlign: 'center' as const,
    },
    infoGrid: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        borderBottom: '1px solid #000',
        paddingBottom: '8px',
        marginBottom: '10px',
    },
    infoItem: {
        width: '50%',
        fontSize: '11px',
        padding: '2px 0',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse' as const,
        marginBottom: '15px',
    },
    th: {
        border: '1px solid #000',
        padding: '5px 8px',
        fontSize: '11px',
        fontWeight: 'bold',
        textAlign: 'left' as const,
        backgroundColor: '#e8e8e8',
    },
    td: {
        border: '1px solid #000',
        padding: '4px 8px',
        fontSize: '11px',
    },
    tdNr: {
        border: '1px solid #000',
        padding: '4px 8px',
        fontSize: '11px',
        textAlign: 'center' as const,
        width: '40px',
    },
    tdFreq: {
        border: '1px solid #000',
        padding: '2px 4px',
        fontSize: '18px',
        fontWeight: 'bold' as const,
        textAlign: 'center' as const,
        width: '25px',
        minWidth: '25px',
    },
    thFreq: {
        border: '1px solid #000',
        padding: '3px 4px',
        fontSize: '9px',
        fontWeight: 'bold',
        textAlign: 'center' as const,
        backgroundColor: '#e8e8e8',
        width: '25px',
        minWidth: '25px',
    },
    infoItemFull: {
        width: '100%',
        fontSize: '11px',
        padding: '2px 0',
    },
    totalRow: {
        fontSize: '12px',
        fontWeight: 'bold',
        padding: '8px 0',
        borderTop: '1px solid #000',
    },
    obsSection: {
        marginTop: '15px',
        borderTop: '1px solid #000',
        paddingTop: '8px',
    },
    obsTitle: {
        fontSize: '12px',
        fontWeight: 'bold',
        marginBottom: '5px',
    },
    obsLine: {
        borderBottom: '1px solid #999',
        height: '22px',
        marginBottom: '2px',
    },
    signatureSection: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: '50px',
        paddingTop: '0px',
    },
    signatureBlock: {
        textAlign: 'center' as const,
        width: '40%',
    },
    signatureLine: {
        borderTop: '1px solid #000',
        paddingTop: '5px',
        fontSize: '11px',
        fontWeight: 'bold',
    },
};

class AtaPresencaImpressao extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { checked: false };
    }

    formatDate(dateStr: string): string {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    }

    render() {
        const { ataData } = this.props;

        if (!ataData) {
            return <div></div>;
        }

        const { header, content, alunos } = ataData;

        if (!header || !content) {
            return <div></div>;
        }

        const discipline = header.discipline?.Description || header.disciplineModule?.discipline?.Description || '';
        const modulo = header.disciplineModule?.Description || '';
        const turma = header.classOffer?.Description || '';
        const sala = header.classOffer?.Room || '';
        const turno = header.classOffer?.Shift || '';
        const professor = header.teacher?.FirstName
            ? `${header.teacher.FirstName} ${header.teacher.LastName || ''}`.trim()
            : '';
        const periodo = header.period?.Description || '';
        const dataAula = this.formatDate(content.Date);
        const cargaHoraria = content.QtyHours || 1;
        const descricao = content.Content || '';
        const observacoes = content.Notes || '';

        // Build hour column headers (1, 2, 3...)
        const hourColumns: number[] = [];
        for (let i = 1; i <= cargaHoraria; i++) {
            hourColumns.push(i);
        }

        // Count total present
        const totalPresentes = (alunos || []).filter(
            (a: any) => a.presencas && a.presencas.some((p: boolean) => p)
        ).length;

        return (
            <div style={styles.page}>
                {/* Header */}
                <div style={styles.headerContainer}>
                    <img
                        src="https://api-fermi.cientificoeducacao.com.br/api/PersonPics/fermi-images.cientificoeducacao.com.br/download/logoCientifico.png"
                        alt="Logo"
                        style={styles.logo}
                    />
                    <div style={styles.headerText}>
                        <p style={styles.headerTitle}>CIENTIFICO</p>
                        <p style={styles.headerSubtitle}>EDUCACAO DE JOVENS E ADULTOS</p>
                        <p style={styles.headerAta}>ATA DE PRESENCA</p>
                    </div>
                </div>

                {/* Info Grid */}
                <div style={styles.infoGrid}>
                    <div style={styles.infoItem}><strong>Disciplina:</strong> {discipline}</div>
                    <div style={styles.infoItem}><strong>Modulo:</strong> {modulo}</div>
                    <div style={styles.infoItem}><strong>Turma:</strong> {turma}</div>
                    <div style={styles.infoItem}><strong>Sala:</strong> {sala} &nbsp;&nbsp; <strong>Turno:</strong> {turno}</div>
                    <div style={styles.infoItem}><strong>Professor:</strong> {professor}</div>
                    <div style={styles.infoItem}><strong>Periodo:</strong> {periodo}</div>
                    <div style={styles.infoItem}><strong>Data:</strong> {dataAula}</div>
                    <div style={styles.infoItem}><strong>Carga Horaria:</strong> {cargaHoraria}h</div>
                    <div style={styles.infoItemFull}><strong>Descricao:</strong> {descricao}</div>
                    <div style={styles.infoItemFull}><strong>Observacoes:</strong> {observacoes}</div>
                </div>

                {/* Students Table */}
                <table style={styles.table}>
                    <thead>
                        <tr>
                            <th style={styles.th}>Nr</th>
                            <th style={styles.th}>Nome do Aluno</th>
                            {hourColumns.map((h) => (
                                <th key={h} style={styles.thFreq}>{h}a</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {(alunos || []).map((aluno: any, index: number) => (
                            <tr key={index}>
                                <td style={styles.tdNr}>{index + 1}</td>
                                <td style={styles.td}>{(aluno.name || '').toUpperCase()}</td>
                                {hourColumns.map((h, hi) => (
                                    <td key={h} style={styles.tdFreq}>
                                        {aluno.presencas && aluno.presencas[hi] ? '.' : ''}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* Total */}
                <div style={styles.totalRow}>
                    Total de alunos: {(alunos || []).length} &nbsp;&nbsp; Presentes: {totalPresentes}
                </div>

                {/* Observations */}
                <div style={styles.obsSection}>
                    <div style={styles.obsTitle}>Observacoes:</div>
                    <div style={styles.obsLine}></div>
                    <div style={styles.obsLine}></div>
                    <div style={styles.obsLine}></div>
                </div>

                {/* Signatures */}
                <div style={styles.signatureSection}>
                    <div style={styles.signatureBlock}>
                        <div style={styles.signatureLine}>Professor</div>
                    </div>
                    <div style={styles.signatureBlock}>
                        <div style={styles.signatureLine}>Coordenacao</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AtaPresencaImpressao;

export const FunctionalAtaPresencaComponentToPrint = React.forwardRef<AtaPresencaImpressao | null, Props>(
    (props, ref) => {
        return <AtaPresencaImpressao ref={ref} {...props} />;
    }
);


type BatchProps = {
    atas: any[];
};

class AtaPresencaBatchImpressao extends React.PureComponent<BatchProps, {}> {
    render() {
        const { atas } = this.props;
        if (!atas || atas.length === 0) return <div></div>;
        return (
            <div>
                {atas.map((ataData: any, index: number) => (
                    <div key={index} style={index > 0 ? { pageBreakBefore: 'always' } : {}}>
                        <AtaPresencaImpressao ataData={ataData} />
                    </div>
                ))}
            </div>
        );
    }
}

export const FunctionalAtaPresencaBatchToPrint = React.forwardRef<AtaPresencaBatchImpressao | null, BatchProps>(
    (props, ref) => {
        return <AtaPresencaBatchImpressao ref={ref} {...props} />;
    }
);
